const env = process.env || {};
const pick = (key, fallback) => env[key] || fallback;

export default {
  kandyApiKey: 'DAK5cff97fc225d417ebd13bb12e46a0cd8',
  kandyLoginTimer: 60000,
  locale: 'zh-cn',
  chromeExtensionId: 'geanejeadifogbjjpjeceibbljgjfimh',
  screenCaptureExtensionId: 'pmpndpdjojcobafjeagljbpkpllecjld',
  companyId: 'eclaim',
  uersTimeOut: 30,
  domain: pick('SERVER_URL', 'https://test-work.eclaimpro.com'),
  rate: ["非常满意", "满意", "一般", "不满意", "非常不满意"],
  callStatus: ['排队中', '开始会话', '取消会话', '结束会话'],
  appType: "lossAss",
  lossAssLink: pick('LOSS_ASS_LINK', 'https://dev.eclaimpro.com/AssessorMain'),
  maxAgents: 50,
  companyName: '上海太平',
  LossLink: pick('LossLink', 'https://boards-dzh-test.eclaimpro.com/loss'),
  searchTenant: '5e3cbb6939e4d500074a3b5e',
  medicalcheckDomain: pick('medicalcheckDomain', 'https://medicalcheck-test.eclaimpro.com'),
  domainForIframe: pick('domainForIframe', 'https://test-support.eclaimpro.com'),
  newMedicalcheckDomain: pick('newMedicalcheckDomain', 'https://medical_new-test.eclaimpro.com/#'),
  server: pick('server', 'tpatest'),
  wxWorkDomain: pick('wxWorkDomain', 'https://tpa-wxwork-test.eclaimpro.com')
}
